// extracted by mini-css-extract-plugin
export default {"wrapper":"ConnectLayout_wrapper__7w-5E","graphic-container":"ConnectLayout_graphic-container__Ebvs5","connect-container":"ConnectLayout_connect-container__HlBg9"};